import React, { Component } from "react";

import Card from "../components/Card";

export default class Introduction extends Component {
  render() {
    return (
      <React.Fragment>
        <Card id="introduction" className="content" headerText="Introduction">
          <p>
            I have always placed computers at the centre of my career. I find
            them captivating and complex devices, which play an ever-greater
            role in people’s lives.
          </p>
          <p>
            After securing a first in Computer Science, I plan to increase and
            enhance my knowledge in the working environment, to gain a more
            practical understanding of software engineering.
          </p>
        </Card>
      </React.Fragment>
    );
  }
}
